const st = typeof localStorage === 'object' ? localStorage : {};

// export const keys = {
//   persist: '__reapro_persist__',
//   user: '__reapro_user__',
//   token: '__reapro_token__',
// };

export const keys = {
  persist: '_dof_sync_persist',
  user: '_dof_sync_user',
  auto_login: '_dof_auto_login',
  recent_login: '_dof_sync_recent_login',
  remember_user_token: '_dof_sync_remember_user_token',
  sign_in_token: '_dof_sync_sign_in_token',
  enrolled_group_codes: '_dof_sync_enrolled_group_codes',
  login_history: '_dof_sync_login_history',
  login_admin_history: '_dof_sync_login_admin_history',
  user_no_repeat: '_dof_sync_no_repeat',
  user_no_notice: '_dof_sync_no_notice',
  notice_modify_date: '_dof_sync_notice_modify_date',
  remember_patient: '_dof_sync_remember_patient',
  language: '_dof_sync_language',
  oem_name: '_dof_sync_oem_name',
};

const storage = {
  set(key, value) {
    st[key] = JSON.stringify(value);
  },
  get(key) {
    if (!st[key]) return null;
    const value = st[key];
    try {
      const parsed = JSON.parse(value);
      return parsed;
    } catch (e) {
      return value;
    }
  },
  remove(key) {
    delete st[key];
  },
  clear() {
    if (st.clear) {
      st.clear();
    }
  },
};

// export function setCookieHour(name, value, hours) {
//   var now = new Date();
//   var time = now.getTime();
//   time += 3600 * hours;
//   now.setTime(time);
//   document.cookie = name + '=' + escape(value) + '; path=/; expires=' + now.toUTCString() + ';';
// }

// export function setCookieDay(name, value, days) {
//   var now = new Date();
//   var time = now.getTime();
//   time += 3600 * 24 * days;
//   now.setTime(time);
//   document.cookie = name + '=' + escape(value) + '; path=/; expires=' + now.toUTCString() + ';';
// }

// 브라우저를 닫으면 지워지는 쿠키설정
export function setSessionCookie(name, value, options = {}) {
  options = {
    path: '/',
    ...options,
    samesite: 'Lax',
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

// 1h * 시간 * 날짜
// const maxAge = 3600 * 24 * 7;
const maxAge = 3600 * 24 * 30;
export function setCookie(name, value, options = {}) {
  options = {
    path: '/',
    // 필요한 경우, 옵션 기본값을 설정할 수도 있습니다.
    'max-age': !!options?.expires ? null : maxAge,
    ...options,
    samesite: 'Lax',
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp('(?:^|; )' + name?.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export default storage;
